import { useCallback, useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  RollingLoader,
  TableHeader,
  TableLoader,
  ToggleSwitch,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
import {
  checkUniqueBranchNameAction,
  createMasterDataBranchAction,
  getAllMasterDataBranchAction,
  getMasterDataBranchAction,
  resetBranchError,
  resetBranchFetching,
  resetBranchMessage,
  resetBranchSatusCode,
  resetIsBranchName,
  resetMasterDataBranchListTotal,
  resetMasterDataLisitng,
  resetMasterError,
  resetMasterMessage,
  resetMasterSuccess,
  updateMasterDataBranchAction,
} from "../../../redux/masterData";
import BranchTables from "../../../components/MasterData/BranchTables";

import { BRANCH_HEADERS } from "../../../constant/tableHeadersConstants/masterDataContants/masterDataBranchListConst";
import {
  CreateBranchDataPayloadType,
  GetAllMasterDataBranchPayloadType,
  UpdateBranchDataPayloadType,
} from "../../../commonTypes/masterDataTypes";
import {
  MasterBranchListingTypes,
} from "../../../redux/masterData/masterTypes";
import { SearchIcon } from "../../../components/Icon";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import BranchFilter, { BRANCH_STATUS_RADIO_OPTIONS } from "./BranchFilter";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import MultiSelect from "../../../components/commons/MultiSelect";
import useDebounce from "../../../customHooks/useDebounce";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type UniqueBranchType = {
  token: string | null;
  operation: string | null;
  branchName: string | null | undefined;
  unique_check:string;
  data_id?:string|null
};

type AppProps = {
  history: any;
  masterDataListing: [];
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  isOpen: boolean;
  branchHeaders: [];
  token: null | string;
  masterDataBranchListTotal: string | number;
  dispatchGetAllMasterDataBranchListAction: (
    data: GetAllMasterDataBranchPayloadType
  ) => void;
  dispatchResetBranchStatusCode:()=>void;
dispatchResetBranchError:()=>void;
dispatchResetBranchMessage:()=>void;
dispatchResetIsBranchName:()=>void;
dispatchResetBranchFetching:()=>void;
  dispatchCheckUnqiueBranchName:(data:any)=>void
  dispatchResetSession: () => void;
  dispatchResetMasterDataListing:()=>void
  dispatchResetMasterDataBranchListTotal:()=>void
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchUpdateMasterDataBranch: (data: UpdateBranchDataPayloadType) => void;
  dispatchAddMasterBranch: (data: CreateBranchDataPayloadType) => void;
  dispatchGetMasterDataBranch: (data:GetAllMasterDataBranchPayloadType) => void;
    isBranchName: null |number;
    branchFetching:boolean;
    branchMessage:string | null;
 
};
const Branch = ({
  masterDataListing,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  masterDataBranchListTotal,
  dispatchResetMasterError,
  dispatchResetMasterDataListing,
  dispatchResetSession,
  dispatchGetAllMasterDataBranchListAction,
  dispatchResetMasterDataBranchListTotal,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetBranchStatusCode,
dispatchResetBranchError,
dispatchResetBranchMessage,
dispatchResetIsBranchName,
dispatchResetBranchFetching,
  dispatchCheckUnqiueBranchName,
  dispatchGetMasterDataBranch,
  dispatchUpdateMasterDataBranch,
  dispatchAddMasterBranch,
  isBranchName,
  branchFetching,
  branchMessage
  
}: AppProps) => {
  const [showAddBranchModal, setShowAddBranchModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [branchName, setBranchName] = useState<string>("");
  const [branchNameError, setBranchNameError] = useState<string>("");
  
  const [uniquebranch, setUniquebranch] = useState<UniqueBranchType>({
    token,
    operation: "",
    branchName: "",
    unique_check:"",
    data_id:"",

  });
  
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
    useState<boolean>(false);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [searchData, setSearchData] = useState("");
  const [data, setData] = useState<[] | MasterBranchListingTypes[]>([]);
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [id, setId] = useState<string | null | undefined>(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [branchStatus, setBranchStatus] = useState<boolean>(false);
  const [activeStatus, setActiveStatus] = useState("");
  const [activeStatusValue, setActiveStatusValue] = useState<string>("");
  //====================User Management=============================
  const [isAddBranchPresent, setIsAddBranchPresent] =
    useMenuCheck();
  const [isEditBranchPresent, setIsEditBranchPresent] =
    useMenuCheck();

  //=================================================================

  
  useEffect(()=>{
    dispatchResetMasterSuccess()
    dispatchResetMasterError()
    dispatchResetMasterMessage()
    dispatchResetMasterDataListing()
    dispatchResetMasterDataBranchListTotal()
    dispatchResetBranchStatusCode();
    dispatchResetBranchError();
    dispatchResetBranchMessage();
    dispatchResetIsBranchName();
    dispatchResetBranchFetching();
    setIsAddBranchPresent("Add Branch", "menu");
    setIsEditBranchPresent("Edit Branch", "menu")
    
  },[])

  useEffect(() => {
    if (masterDataListing?.length === 0) {
      setData(masterDataListing);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...masterDataListing]);
    } else {
      setData(masterDataListing);
    }
  }, [masterDataListing]);

  useEffect(() => {
    setIsMultiSelectPresent(false);
  }, []);

  useEffect(() => {
    let finalData ={search_term: searchData , token , branch_status: activeStatus}
    dispatchGetMasterDataBranch(finalData);
  }, []);

  useEffect(() => {
    if (token) {
      let finalData: GetAllMasterDataBranchPayloadType = {
        token,
        limit,
        offset,
        search_term: searchData,
        branch_status: activeStatus,
      };
      
      if(clearFilter){
        finalData.branch_status="";
        setActiveStatus("");
        setActiveStatusValue("");
        setClearFilter(false)
      }
      
      if (offset < +masterDataBranchListTotal) {
        dispatchGetAllMasterDataBranchListAction(finalData);
      } else if (offset === 0 && masterDataBranchListTotal === "") {
        dispatchGetAllMasterDataBranchListAction(finalData);
      }
    }
  }, [offset , clearFilter]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  useEffect(() => {
    if (!showAddBranchModal) {
      setIsEdit(false);
    }
  }, [showAddBranchModal]);



  const handleBranchNameChange = (e: any) => {
    let branchNameInput = e.target.value
    if(isEdit){
      const finalData = {
        token,
        operation: "update",
        branchName: branchNameInput.trim(),
        unique_check:"branch",
        data_id:id
      };
      dispatchResetBranchStatusCode();
      dispatchResetBranchError();
      dispatchResetBranchMessage();
      dispatchResetIsBranchName();
      dispatchResetBranchFetching();
      setUniquebranch(finalData);

    }
    else{
      const finalData = {
        token,
        operation: "add",
        branchName: branchNameInput.trim(),
        unique_check:"branch"
      };
      dispatchResetBranchStatusCode();
      dispatchResetBranchError();
      dispatchResetBranchMessage();
      dispatchResetIsBranchName();
      dispatchResetBranchFetching();
      setUniquebranch(finalData);
      

    }
    setBranchName(e.target.value);
    if (branchNameError) {
      setBranchNameError("");
    }
  };

  const toggleAddBranchModal = () => {
    setBranchStatus(false);
    if (!showAddBranchModal) {
      handleResetData();
    }
    setShowAddBranchModal(!showAddBranchModal);
  };

  const handleToogleIsBranch = () => {
    setBranchStatus(!branchStatus);
  };

  const handleResetData = () => {
    setBranchName("");
  };
  const fetchNewData = () => {
    if (token) {
      let finalData = {
        token,
        search_term: searchData,
        
        limit,
        branch_status: activeStatus,
        offset,
      };
      if (offset === 0) {
        dispatchGetAllMasterDataBranchListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  useDebounce(
    () => {
      if (branchName) {
        dispatchCheckUnqiueBranchName(uniquebranch);
      }
    },
    500,
    [uniquebranch]
  )

  useEffect(() => {
    dispatchResetMasterDataListing();
    dispatchResetMasterDataBranchListTotal();
    getData();
    setOffset(0);
    setIsMultiSelectPresent(true);
    if (
      (activeStatus && isMultiSelectPresent) ||
      (!activeStatus && isMultiSelectPresent)
    ) {
      if (offset === 0&&token) {

        let finalData = {
          token,
          limit,
          offset,
          search_term: searchData,
          branch_status: activeStatus,
        };
        dispatchGetAllMasterDataBranchListAction(finalData); 
      }
    }
  }, [activeStatus]);

  const getData = useCallback(() => {
    const getBranchStatusValue = BRANCH_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => String(item.id) === String(activeStatus)
    );
    setMultiSelectData([getBranchStatusValue]);
  }, [activeStatus]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
        branch_status: activeStatus,
      
      };
      dispatchGetAllMasterDataBranchListAction(finalData);
    }
  };

  const handleEditMasterBranch = (data: MasterBranchListingTypes) => {
    dispatchResetBranchStatusCode();
    dispatchResetBranchError();
    dispatchResetBranchMessage();
    dispatchResetIsBranchName();
    dispatchResetBranchFetching();
    setIsEdit(true);
    setShowAddBranchModal(true);
    setBranchName(data?.branch_name);
    setBranchStatus(data?.branch_status);
    setIsEdit(true);
    setId(data?._id);
  };

  const handleAddBranch = (e: MasterBranchListingTypes) => {
    dispatchResetBranchStatusCode();
    dispatchResetBranchError();
    dispatchResetBranchMessage();
    dispatchResetIsBranchName();
    dispatchResetBranchFetching();
    if (branchName?.trim()?.length > 0) {
      if (isEdit) {
        let updateData: UpdateBranchDataPayloadType = {
          branch_name: branchName,
          branch_status: branchStatus === true ? 1 : 0,
          token: token,
          _id: id,
        };

        dispatchUpdateMasterDataBranch(updateData);
        handleSuccessMessage("update-master-branch");
      } else {
        let finalAddData = {
          branch_name: branchName,
          branch_status: branchStatus === true ? 1 : 0,
          token: token,
        };
        setClearFilter(true)
        dispatchAddMasterBranch(finalAddData);
        handleSuccessMessage("created-master-branch");
        setSearchData("")
      }
    } 
  };

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "created-master-branch":
        return setSuccessMessage("Branch Data Added Successfully!");
      case "update-master-branch":
        return setSuccessMessage("Branch Data Updated Successfully!");
      default:
        return setSuccessMessage("");
    }
  };

  const onScroll = () => {
    if(!fetching){

    
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (offset < +masterDataBranchListTotal && !fetching && Math.ceil(75 / 100 * scrollHeight) <= scrollTop + clientHeight){
      if (masterDataListing?.length > 0) {
        if(!fetching && offset < +masterDataBranchListTotal){
            setOffset(offset + limit);
        }
          }
    }
  }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [masterDataListing]);

  const onClose = (id: any) => {
    const checkActiveStatusValue = BRANCH_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => item._id == id
    );
    if (checkActiveStatusValue) {
      setActiveStatus("");
      setActiveStatusValue("");
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      }
    }

    if (success === 1 && message == "Branch has been added successfully!") {
      let finalData ={search_term: searchData , token , branch_status: activeStatus}
      dispatchGetMasterDataBranch(finalData);
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });

      if (token) {
        if (offset === 0) {
          let finalData = { token, offset: 0, limit ,search_term: searchData,
          };
          dispatchGetAllMasterDataBranchListAction(finalData);
        }
      }
    }
    if (success === 1 && message == "Branch has been updated successfully!") {
      let finalData ={search_term: searchData , token , branch_status: activeStatus}
      dispatchGetMasterDataBranch(finalData);
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
    }

    return false;
  };

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);
  

  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Branch" />
      </div>
      <div className="col-md-6 text-right">
        {!!masterDataListing?.length && isAddBranchPresent && ( 
        <button className="btn btn-primary" onClick={toggleAddBranchModal}>
          + Add Branch
        </button>
        )}
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading"> Branch List</div>
              {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${masterDataBranchListTotal ? masterDataBranchListTotal : 0
                } entries found`}</div>}
            <div> <MultiSelect data={multiSelectData} onClose={onClose} /></div>

            </div>
            <div
              className="text-right d-flex flex-row col-lg-8"
              style={{ justifyContent: "flex-end" }}
            >
              <div
                className="mr-2 w-auto position-relative"
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "13px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>

              <div className="form-group mr-1">
                <BranchFilter
                  activeStatus={activeStatus}
                  setActiveStatus={setActiveStatus}
                  activeStatusValue={activeStatusValue}
                  setActiveStatusValue={setActiveStatusValue}
                  setClearFilter={setClearFilter}
                  setOffset={setOffset}
                  setData={setData}
                />
              </div>
            </div>
          </div>

            <>
              {fetching && offset == 0 ? 
                <TableLoader Rows={10} ColumnPerRow={7} />
               :masterDataListing?.length>0?(
                <div className="jobsType">
                      <table className="table thead-light table-bordered">
                        <thead className="text-left sticky-table-header">
                          <TableHeader tableHeader={BRANCH_HEADERS} />
                        </thead>
                        <tbody>
                          <BranchTables
                            data={data}
                            tableHeaders={BRANCH_HEADERS}
                            handleEditMasterBranch={handleEditMasterBranch}
                            isEditBranchPresent={isEditBranchPresent}
                          />
                          <div
                            style={{ display: fetching ? "none" : "inline" }}
                          >
                            <ScrollToTop />
                          </div>
                          {fetching && offset > 0 && (
                            <div>{<InfiniteLoader />}</div>
                          )}
                        </tbody>
                      </table>
                </div>
              ):<>
               {!fetching&&data?.length===0&&<EmptyListPage
              title="No Branch List Found!"
              text={isAddBranchPresent?"Add a branch data to see it here in the list!":""}
              imageWidth="30%"
              showAddButton={isAddBranchPresent}
              buttonTitle="+ Add Branch"
              onButtonClick={toggleAddBranchModal}

            />}</>
            }
            </>
        </div>
      </div>
      {showAddBranchModal ? (
        <Modal isOpen={showAddBranchModal} toggle={toggleAddBranchModal}>
          <ModalHeader className="pt-4 pl-4">
            {`${isEdit ? "Edit" : "Add"} Branch`}
          </ModalHeader>
          <ModalBody className="pl-4 pr-4">
            <form>
              <div className="form-group mt-3">
                <div>
                  <label
                    htmlFor="foldername"
                    className={branchName ? "active" : ""}
                  >
                    Enter Branch Name <span className='color-red'>*</span>
                  </label>
                  <div className="d-flex flex-row position-relative">
                  <input
                    type="text"
                    className={`form-control ${
                      !!branchNameError ? "error-border" : null
                    }`}
                    name="text"
                    value={branchName}
                    autoFocus
                    onChange={(e) => handleBranchNameChange(e)}
                    maxLength={60}
                    onKeyPress={(e: any) =>
                      e.key === "Enter" ? handleAddBranch(e) : null
                    }
                  />
                    {branchFetching&&<RollingLoader/>}</div>
                    { isBranchName === 1 && branchName?.trim().length&& branchMessage?.includes("already exists") ?
            <small className="text-danger">
              Branch Name is already in use!
            </small> : ""
          }
                  {!!branchNameError && (
                    <small className="text-danger">{branchNameError}</small>
                  )}
                </div>
                <span className="input-length">
                  {returnInputFieldLength(branchName?.length, 60)}
                </span>
              </div>
              <div className="col-md-5">
                <label htmlFor="status">Branch Status</label>
                <ToggleSwitch
                  handleToggleChange={handleToogleIsBranch}
                  isChecked={branchStatus}
                />
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <span className="pointer" onClick={toggleAddBranchModal}>
              Cancel
            </span>
            <Button
              color="primary ml-3"
              onClick={(e: any) => {
                handleAddBranch(e);
                toggleAddBranchModal();
              }}
              disabled={!branchName ||isBranchName === 1 && branchMessage?.includes("already exists") 
            }
            >
              {isEdit ? "Update Branch" : "Add Branch"}
            </Button>
          </ModalFooter>
        </Modal>
      ) : (
        ""
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  masterDataListing: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  success: state.masterData.success,
  message: state.masterData.message,
  branchMessage: state.masterData.branchMessage,
  branchFetching: state.masterData.branchFetching,
  isBranchName: state.masterData.isBranchName,

});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchAddMasterBranch: (data: CreateBranchDataPayloadType) =>
    dispatch(createMasterDataBranchAction(data)),
  dispatchGetMasterDataBranch: (data: GetAllMasterDataBranchPayloadType) => {
    dispatch(getMasterDataBranchAction(data));
  },
  dispatchUpdateMasterDataBranch: (data: UpdateBranchDataPayloadType) => {
    dispatch(updateMasterDataBranchAction(data));
  },
  dispatchCheckUnqiueBranchName :(data:any)=>dispatch(checkUniqueBranchNameAction(data)),
  dispatchGetAllMasterDataBranchListAction: (
    data: GetAllMasterDataBranchPayloadType
  ) => dispatch(getAllMasterDataBranchAction(data)),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterDataListing :()=>dispatch(resetMasterDataLisitng()),
  dispatchResetMasterDataBranchListTotal:()=>dispatch(resetMasterDataBranchListTotal()),
  dispatchResetBranchStatusCode : ()=>dispatch(resetBranchSatusCode()),
  dispatchResetBranchError :()=>dispatch(resetBranchError()),
  dispatchResetBranchMessage :()=>dispatch(resetBranchMessage()),
  dispatchResetIsBranchName:()=>dispatch(resetIsBranchName()),
  dispatchResetBranchFetching :()=>dispatch(resetBranchFetching())
});

export default connect(mapStateToProps, mapDispatchToProps)(Branch);
